'use client'

import { Input } from '@/components/ui/input'
import { FieldShell, premiumControlClass } from './field-shell'
import type { AnswerableFieldProps } from './types'

export function DateField({ props, mode, value, onChange, error }: AnswerableFieldProps<'Date', string>) {
  const isPreview = mode === 'preview'
  return (
    <FieldShell
      mode={mode}
      htmlFor={props.id}
      label={props.label}
      required={props.required}
      helpText={props.helpText}
      error={error}
      conditional={Boolean(props.showIf)}
    >
      <Input
        id={props.id}
        type="date"
        className={premiumControlClass}
        readOnly={isPreview}
        value={isPreview ? '' : typeof value === 'string' ? value : ''}
        onChange={isPreview ? undefined : e => onChange?.(e.target.value)}
      />
    </FieldShell>
  )
}
